// Contenu légal multilingue (RGPD / AdSense / Stripe)
// Éditeur : Destin Express — contact@destinexpress.com — France — https://destinexpress.com

const EDITOR = "Destin Express";
const EMAIL = "contact@destinexpress.com";
const SITE = "destinexpress.com";
const COUNTRY_FR = "France";

export const legalContent = {
  fr: {
    updated: "Dernière mise à jour : juin 2026",
    tabs: {
      privacy: "Confidentialité",
      notice: "Mentions légales",
      terms: "CGU / CGV",
      refund: "Remboursement",
    },
    privacy: [
      {
        h: "1. Responsable du traitement",
        p: [
          `Le site ${SITE} (« Destin Express ») est édité par ${EDITOR}, résidant en ${COUNTRY_FR}. Pour toute question relative à vos données personnelles, vous pouvez nous contacter à l'adresse : ${EMAIL}.`,
        ],
      },
      {
        h: "2. Données que nous collectons",
        p: [
          "Pseudo : le pseudonyme que vous choisissez pour jouer et apparaître au classement.",
          "Compte Google (facultatif) : si vous vous connectez via Google, nous recevons votre adresse e-mail, votre nom et votre photo de profil afin de sauvegarder vos achats et vos skins.",
          "Données de jeu : vos scores, domaines joués, statistiques et titres, stockés pour le classement mondial.",
          "Achats : en cas d'achat de skin, le paiement est traité par Stripe. Nous ne stockons jamais vos données bancaires.",
          "Données techniques et d'usage : via l'outil de mesure d'audience PostHog (pages vues, interactions, appareil, langue) afin d'améliorer le jeu.",
        ],
      },
      {
        h: "3. Cookies et publicité",
        p: [
          "Destin Express est gratuit grâce à la publicité (Google AdSense). Avec votre consentement, des cookies publicitaires peuvent être déposés pour afficher des annonces personnalisées.",
          "Vous pouvez accepter ou refuser les publicités personnalisées via notre bandeau de consentement, et modifier votre choix à tout moment. En cas de refus, des publicités non personnalisées peuvent toujours s'afficher.",
          "Nous utilisons également des cookies techniques (stockage local) pour mémoriser votre pseudo, votre langue et vos préférences.",
        ],
      },
      {
        h: "4. Bases légales et finalités",
        p: [
          "Exécution du service (jeu, classement, compte) : intérêt légitime et exécution du contrat.",
          "Publicité personnalisée et mesure d'audience : votre consentement.",
          "Traitement des paiements : exécution du contrat et obligations légales.",
        ],
      },
      {
        h: "5. Partage des données",
        p: [
          "Google (AdSense, authentification) : voir la politique de confidentialité de Google.",
          "Stripe (paiements sécurisés) : voir la politique de confidentialité de Stripe.",
          "PostHog (mesure d'audience) : voir la politique de confidentialité de PostHog.",
          "Nous ne vendons jamais vos données personnelles.",
        ],
      },
      {
        h: "6. Durée de conservation",
        p: [
          "Les données de compte et de jeu sont conservées tant que votre compte est actif. Vous pouvez demander leur suppression à tout moment.",
        ],
      },
      {
        h: "7. Vos droits (RGPD)",
        p: [
          `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Pour exercer ces droits, écrivez-nous à ${EMAIL}.`,
          "Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        ],
      },
    ],
    notice: [
      {
        h: "Éditeur du site",
        p: [
          `Le site ${SITE} est édité par ${EDITOR}.`,
          `Pays : ${COUNTRY_FR}.`,
          `Contact : ${EMAIL}.`,
          `Directeur de la publication : ${EDITOR}.`,
        ],
      },
      {
        h: "Hébergement",
        p: [
          "Le site est hébergé sur l'infrastructure cloud de la plateforme Emergent (Emergent Labs).",
        ],
      },
      {
        h: "Propriété intellectuelle",
        p: [
          `L'ensemble des contenus du site (textes, visuels, logo, code, mécaniques de jeu) est la propriété de ${EDITOR}, sauf mentions contraires. Toute reproduction non autorisée est interdite.`,
        ],
      },
    ],
    terms: [
      {
        h: "1. Objet",
        p: [
          `Les présentes conditions régissent l'utilisation du jeu Destin Express accessible sur ${SITE}. En utilisant le site, vous acceptez ces conditions.`,
        ],
      },
      {
        h: "2. Accès au service",
        p: [
          "Destin Express est un jeu de divertissement gratuit accessible depuis un navigateur. Un compte Google facultatif permet de sauvegarder ses achats.",
          "Le jeu s'adresse à un public de 13 ans et plus. Les mineurs doivent obtenir l'autorisation de leur représentant légal, notamment pour tout achat.",
        ],
      },
      {
        h: "3. Comportement des utilisateurs",
        p: [
          "Vous vous engagez à ne pas tricher, ne pas tenter de fausser le classement, et à choisir un pseudo respectueux (pas de contenu injurieux, haineux ou illégal). Nous nous réservons le droit de retirer tout contenu inapproprié.",
        ],
      },
      {
        h: "4. Achats (CGV)",
        p: [
          "Destin Express propose des biens numériques payants (skins de carte premium). Les prix sont indiqués en euros, taxes comprises le cas échéant.",
          "Le paiement est traité de manière sécurisée par Stripe. La livraison du bien numérique est immédiate après validation du paiement (déblocage du skin sur votre compte).",
        ],
      },
      {
        h: "5. Responsabilité",
        p: [
          "Le service est fourni « en l'état ». Nous nous efforçons d'assurer sa disponibilité mais ne garantissons pas une absence totale d'interruption ou d'erreur.",
        ],
      },
      {
        h: "6. Droit applicable",
        p: [
          `Les présentes conditions sont soumises au droit français. Pour tout litige, vous pouvez nous contacter à ${EMAIL}.`,
        ],
      },
    ],
    refund: [
      {
        h: "Politique de remboursement",
        p: [
          "Les skins premium sont des contenus numériques livrés immédiatement après l'achat.",
          "Conformément à l'article L221-28 du Code de la consommation, en achetant un contenu numérique livré immédiatement, vous demandez expressément son exécution avant la fin du délai de rétractation et renoncez donc à votre droit de rétractation de 14 jours une fois le skin débloqué.",
          `En cas de problème technique (skin payé mais non débloqué, double paiement), contactez-nous à ${EMAIL} : nous corrigerons la situation ou procéderons au remboursement du paiement concerné.`,
        ],
      },
    ],
  },

  en: {
    updated: "Last updated: June 2026",
    tabs: {
      privacy: "Privacy",
      notice: "Legal Notice",
      terms: "Terms",
      refund: "Refunds",
    },
    privacy: [
      {
        h: "1. Data controller",
        p: [
          `The website ${SITE} ("Destin Express") is operated by ${EDITOR}, based in ${COUNTRY_FR}. For any question about your personal data, contact us at: ${EMAIL}.`,
        ],
      },
      {
        h: "2. Data we collect",
        p: [
          "Nickname: the nickname you choose to play and appear on the leaderboard.",
          "Google account (optional): if you sign in with Google, we receive your email, name and profile picture to save your purchases and skins.",
          "Game data: your scores, played fields, stats and titles, stored for the global leaderboard.",
          "Purchases: skin payments are processed by Stripe. We never store your card details.",
          "Technical and usage data: via the PostHog analytics tool (page views, interactions, device, language) to improve the game.",
        ],
      },
      {
        h: "3. Cookies and advertising",
        p: [
          "Destin Express is free thanks to advertising (Google AdSense). With your consent, advertising cookies may be set to display personalized ads.",
          "You can accept or decline personalized ads via our consent banner and change your choice at any time. If declined, non-personalized ads may still appear.",
          "We also use technical cookies (local storage) to remember your nickname, language and preferences.",
        ],
      },
      {
        h: "4. Legal bases and purposes",
        p: [
          "Providing the service (game, leaderboard, account): legitimate interest and contract performance.",
          "Personalized advertising and analytics: your consent.",
          "Payment processing: contract performance and legal obligations.",
        ],
      },
      {
        h: "5. Data sharing",
        p: [
          "Google (AdSense, authentication): see Google's privacy policy.",
          "Stripe (secure payments): see Stripe's privacy policy.",
          "PostHog (analytics): see PostHog's privacy policy.",
          "We never sell your personal data.",
        ],
      },
      {
        h: "6. Retention",
        p: [
          "Account and game data are kept as long as your account is active. You can request deletion at any time.",
        ],
      },
      {
        h: "7. Your rights (GDPR)",
        p: [
          `Under the GDPR, you have the right to access, rectify, erase, restrict, object to and port your data. To exercise these rights, email us at ${EMAIL}.`,
          "You may also lodge a complaint with your local data protection authority.",
        ],
      },
    ],
    notice: [
      {
        h: "Site operator",
        p: [
          `The website ${SITE} is operated by ${EDITOR}.`,
          `Country: ${COUNTRY_FR}.`,
          `Contact: ${EMAIL}.`,
          `Publication director: ${EDITOR}.`,
        ],
      },
      {
        h: "Hosting",
        p: [
          "The site is hosted on the cloud infrastructure of the Emergent platform (Emergent Labs).",
        ],
      },
      {
        h: "Intellectual property",
        p: [
          `All site content (text, visuals, logo, code, game mechanics) is the property of ${EDITOR}, unless stated otherwise. Any unauthorized reproduction is prohibited.`,
        ],
      },
    ],
    terms: [
      {
        h: "1. Purpose",
        p: [
          `These terms govern the use of the Destin Express game available at ${SITE}. By using the site, you accept these terms.`,
        ],
      },
      {
        h: "2. Access to the service",
        p: [
          "Destin Express is a free entertainment game accessible from a browser. An optional Google account lets you save your purchases.",
          "The game is intended for users aged 13 and over. Minors must obtain permission from their legal guardian, in particular for any purchase.",
        ],
      },
      {
        h: "3. User conduct",
        p: [
          "You agree not to cheat, not to attempt to falsify the leaderboard, and to choose a respectful nickname (no abusive, hateful or illegal content). We reserve the right to remove any inappropriate content.",
        ],
      },
      {
        h: "4. Purchases (Terms of Sale)",
        p: [
          "Destin Express offers paid digital goods (premium card skins). Prices are shown in euros, including taxes where applicable.",
          "Payment is securely processed by Stripe. The digital good is delivered immediately after payment (the skin is unlocked on your account).",
        ],
      },
      {
        h: "5. Liability",
        p: [
          'The service is provided "as is". We strive to keep it available but do not guarantee it will be entirely free of interruptions or errors.',
        ],
      },
      {
        h: "6. Governing law",
        p: [
          `These terms are governed by French law. For any dispute, you can contact us at ${EMAIL}.`,
        ],
      },
    ],
    refund: [
      {
        h: "Refund policy",
        p: [
          "Premium skins are digital content delivered immediately after purchase.",
          "By purchasing digital content delivered immediately, you expressly request its execution and waive your 14-day right of withdrawal once the skin is unlocked.",
          `In case of a technical issue (skin paid but not unlocked, double charge), contact us at ${EMAIL}: we will fix the situation or refund the relevant payment.`,
        ],
      },
    ],
  },

  es: {
    updated: "Última actualización: junio de 2026",
    tabs: {
      privacy: "Privacidad",
      notice: "Aviso legal",
      terms: "Condiciones",
      refund: "Reembolsos",
    },
    privacy: [
      {
        h: "1. Responsable del tratamiento",
        p: [
          `El sitio ${SITE} («Destin Express») está gestionado por ${EDITOR}, con residencia en ${COUNTRY_FR}. Para cualquier consulta sobre tus datos personales, contáctanos en: ${EMAIL}.`,
        ],
      },
      {
        h: "2. Datos que recopilamos",
        p: [
          "Apodo: el apodo que eliges para jugar y aparecer en la clasificación.",
          "Cuenta de Google (opcional): si inicias sesión con Google, recibimos tu correo, nombre y foto de perfil para guardar tus compras y skins.",
          "Datos de juego: tus puntuaciones, campos jugados, estadísticas y títulos, almacenados para la clasificación mundial.",
          "Compras: los pagos de skins los procesa Stripe. Nunca almacenamos tus datos bancarios.",
          "Datos técnicos y de uso: mediante la herramienta de analítica PostHog (páginas vistas, interacciones, dispositivo, idioma) para mejorar el juego.",
        ],
      },
      {
        h: "3. Cookies y publicidad",
        p: [
          "Destin Express es gratuito gracias a la publicidad (Google AdSense). Con tu consentimiento, pueden instalarse cookies publicitarias para mostrar anuncios personalizados.",
          "Puedes aceptar o rechazar los anuncios personalizados mediante nuestro banner de consentimiento y cambiar tu elección en cualquier momento. Si los rechazas, aún pueden mostrarse anuncios no personalizados.",
          "También usamos cookies técnicas (almacenamiento local) para recordar tu apodo, idioma y preferencias.",
        ],
      },
      {
        h: "4. Bases legales y finalidades",
        p: [
          "Prestación del servicio (juego, clasificación, cuenta): interés legítimo y ejecución del contrato.",
          "Publicidad personalizada y analítica: tu consentimiento.",
          "Procesamiento de pagos: ejecución del contrato y obligaciones legales.",
        ],
      },
      {
        h: "5. Compartición de datos",
        p: [
          "Google (AdSense, autenticación): consulta la política de privacidad de Google.",
          "Stripe (pagos seguros): consulta la política de privacidad de Stripe.",
          "PostHog (analítica): consulta la política de privacidad de PostHog.",
          "Nunca vendemos tus datos personales.",
        ],
      },
      {
        h: "6. Conservación",
        p: [
          "Los datos de cuenta y de juego se conservan mientras tu cuenta esté activa. Puedes solicitar su eliminación en cualquier momento.",
        ],
      },
      {
        h: "7. Tus derechos (RGPD)",
        p: [
          `Conforme al RGPD, tienes derecho de acceso, rectificación, supresión, limitación, oposición y portabilidad de tus datos. Para ejercerlos, escríbenos a ${EMAIL}.`,
          "También puedes presentar una reclamación ante tu autoridad de protección de datos.",
        ],
      },
    ],
    notice: [
      {
        h: "Editor del sitio",
        p: [
          `El sitio ${SITE} está gestionado por ${EDITOR}.`,
          `País: ${COUNTRY_FR}.`,
          `Contacto: ${EMAIL}.`,
          `Director de publicación: ${EDITOR}.`,
        ],
      },
      {
        h: "Alojamiento",
        p: [
          "El sitio está alojado en la infraestructura cloud de la plataforma Emergent (Emergent Labs).",
        ],
      },
      {
        h: "Propiedad intelectual",
        p: [
          `Todo el contenido del sitio (textos, imágenes, logo, código, mecánicas de juego) es propiedad de ${EDITOR}, salvo indicación contraria. Queda prohibida cualquier reproducción no autorizada.`,
        ],
      },
    ],
    terms: [
      {
        h: "1. Objeto",
        p: [
          `Estas condiciones regulan el uso del juego Destin Express disponible en ${SITE}. Al usar el sitio, aceptas estas condiciones.`,
        ],
      },
      {
        h: "2. Acceso al servicio",
        p: [
          "Destin Express es un juego de entretenimiento gratuito accesible desde el navegador. Una cuenta de Google opcional permite guardar tus compras.",
          "El juego está destinado a mayores de 13 años. Los menores deben obtener la autorización de su representante legal, en particular para cualquier compra.",
        ],
      },
      {
        h: "3. Conducta del usuario",
        p: [
          "Te comprometes a no hacer trampas, a no falsear la clasificación y a elegir un apodo respetuoso (sin contenido ofensivo, de odio o ilegal). Nos reservamos el derecho de eliminar cualquier contenido inapropiado.",
        ],
      },
      {
        h: "4. Compras (Condiciones de venta)",
        p: [
          "Destin Express ofrece bienes digitales de pago (skins de tarjeta premium). Los precios se indican en euros, impuestos incluidos cuando corresponda.",
          "El pago lo procesa de forma segura Stripe. El bien digital se entrega inmediatamente tras el pago (el skin se desbloquea en tu cuenta).",
        ],
      },
      {
        h: "5. Responsabilidad",
        p: [
          'El servicio se presta «tal cual». Nos esforzamos por mantenerlo disponible, pero no garantizamos la ausencia total de interrupciones o errores.',
        ],
      },
      {
        h: "6. Ley aplicable",
        p: [
          `Estas condiciones se rigen por la ley francesa. Para cualquier disputa, puedes contactarnos en ${EMAIL}.`,
        ],
      },
    ],
    refund: [
      {
        h: "Política de reembolso",
        p: [
          "Los skins premium son contenidos digitales entregados inmediatamente tras la compra.",
          "Al comprar contenido digital entregado de inmediato, solicitas expresamente su ejecución y renuncias a tu derecho de desistimiento de 14 días una vez desbloqueado el skin.",
          `En caso de problema técnico (skin pagado pero no desbloqueado, cobro doble), contáctanos en ${EMAIL}: corregiremos la situación o reembolsaremos el pago correspondiente.`,
        ],
      },
    ],
  },
};

export const LEGAL_TABS = ["privacy", "notice", "terms", "refund"];

// Mapping URL -> onglet pour un accès crawlable
export const LEGAL_PATHS = {
  "/privacy": "privacy",
  "/legal": "notice",
  "/terms": "terms",
  "/refund": "refund",
};
